/**
 * ProfileFieldEditDialog — one-field edit modal for the Account card on
 * /profile. Opened from the pencil next to First name / Last name / Phone; the
 * form is an RffForm so the fields keep the label-above wrappers used elsewhere,
 * and the submit posts only the edited key (update_user_by_id $sets sent fields).
 */
import Alert from "@mui/material/Alert";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import RffForm from "../../components/finalForm/RffForm";
import RffTextField from "../../components/finalForm/inputs/RffTextField";
import RffPhoneField from "../../components/finalForm/inputs/RffPhoneField";

// The three self-editable B2BUser fields. `key` is the doc field the backend
// receives; `kind` picks the input.
export const PROFILE_EDIT_FIELDS = {
  firstName: { key: "firstName", label: "First name", kind: "text", required: true },
  lastName: { key: "lastName", label: "Last name", kind: "text", required: true },
  phone_number: { key: "phone_number", label: "Phone", kind: "phone", required: false },
};

export default function ProfileFieldEditDialog({
  open,
  field,
  value,
  submitting,
  error,
  onSave,
  onClose,
}) {
  const handleClose = () => {
    if (submitting) return;
    onClose?.();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontSize: 16, fontWeight: 700 }}>
        {field ? `Edit ${field.label.toLowerCase()}` : "Edit"}
      </DialogTitle>
      <DialogContent sx={{ pt: "6px !important" }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {field && (
          <RffForm
            // Remount per field so initialValues re-seed when switching rows.
            key={field.key}
            formSpy={false}
            onSubmit={(values) => onSave?.(field.key, values[field.key])}
            onCancel={handleClose}
            initialValues={{ [field.key]: value ?? "" }}
            gap="16px"
            maxWidth={false}
            submitText={submitting ? "Saving…" : "Save"}
            loading={submitting}
            disabled={submitting}
          >
            {field.kind === "phone" ? (
              <RffPhoneField name={field.key} label={field.label} required={field.required} />
            ) : (
              <RffTextField name={field.key} label={field.label} required={field.required} />
            )}
          </RffForm>
        )}
      </DialogContent>
    </Dialog>
  );
}
